import React, { useState } from 'react';

import Tooltip from '@components/Tooltip';
import { emailValidator } from '@utils/Validators';
import debounce from '@utils/debounce';
import {
  QuestionContainer,
  QuestionHeader,
  QuestionTitle,
  QuestionSubtitle,
  Input,
  InfoTooltip,
  TooltipContainer,
} from '../common';
import { EmailProps } from './interfaces';

const Email: React.FC<EmailProps> = ({
  question,
  errors,
  initialValues,
  onChange,
  viewOnly = false,
}) => {
  // Handle both string and array values
  const getInitialEmailString = (): string => {
    const values = initialValues?.values;
    if (Array.isArray(values)) {
      return values.join(', ');
    }
    return values || '';
  };

  const [email, setEmail] = useState<string>(getInitialEmailString());
  const [debouncedEmail] = useState(() =>
    debounce(async (newText: string) => {
      const parsed = newText
        .split(',')
        .filter((el) => el.length)
        .map((el) => el.trim());

      setEmail(newText);
      const allValid = parsed.some((e) => !emailValidator(e));
      if (parsed.length > 0) onChange(parsed);
      if (allValid) onChange(parsed);
    }, 200),
  );

  // Get display value for input
  const getDisplayValue = (): string => {
    const values = initialValues?.values;
    if (Array.isArray(values)) {
      return values.join(', ');
    }
    return values || '';
  };

  return (
    <QuestionContainer>
      <QuestionHeader>
        <QuestionTitle>{question.name}</QuestionTitle>
        {question.tipText && (
          <Tooltip description={question.tipText} placement="top right">
            <TooltipContainer>
              <InfoTooltip />
            </TooltipContainer>
          </Tooltip>
        )}
      </QuestionHeader>
      <Input
        disabled={viewOnly}
        type="text"
        onChange={(e) => debouncedEmail(e.target.value)}
        hasError={
          (email ? !email?.split(',').some((e) => emailValidator(e)) : false) ||
          !!errors?.errors
        }
        defaultValue={getDisplayValue()}
      />
      <QuestionSubtitle hasError={!!errors}>
        {errors && errors.errors}
      </QuestionSubtitle>
    </QuestionContainer>
  );
};

export default Email;
